// Janela lateral no estilo do cliente: título com ícone, botões de minimizar e fechar.
// O estado (minimizada/fechada) fica salvo no navegador.
import type { ComponentChildren } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const IMG = '/assets/interface/images';

function load(key: string): { min: boolean; closed: boolean } {
  try { return JSON.parse(localStorage.getItem('noxara.widget.' + key) ?? '') ?? { min: false, closed: false }; }
  catch { return { min: false, closed: false }; }
}
function save(key: string, v: { min: boolean; closed: boolean }) {
  try { localStorage.setItem('noxara.widget.' + key, JSON.stringify(v)); } catch { /* sem armazenamento */ }
}

export function Widget(props: {
  id: string; title: string; icon?: string; children: ComponentChildren;
  grow?: boolean; closable?: boolean; headerExtra?: ComponentChildren;
}) {
  const [st, setSt] = useState(() => load(props.id));
  const set = (v: typeof st) => { setSt(v); save(props.id, v); };
  useEffect(() => {
    const on = (e: Event) => { if ((e as CustomEvent).detail === props.id) setSt(load(props.id)); };
    window.addEventListener('noxara-widget', on);
    return () => window.removeEventListener('noxara-widget', on);
  }, [props.id]);
  if (st.closed) return null;
  return (
    <section class={'w-widget' + (st.min ? ' min' : '') + (props.grow && !st.min ? ' grow' : '')}>
      <header class="w-title">
        {props.icon && <img src={props.icon} alt="" />}
        <span>{props.title}</span>
        <span class="w-title-btns">
          <button class="w-min" title={st.min ? 'Expandir' : 'Minimizar'} onClick={() => set({ ...st, min: !st.min })}
            style={{ backgroundImage: `url(${IMG}/skin/classic/${st.min ? 'max' : 'min'}-button-small-up.png)` }} />
          {props.closable !== false && (
            <button class="w-close" title="Fechar" onClick={() => set({ ...st, closed: true })}
              style={{ backgroundImage: `url(${IMG}/skin/classic/exit-button-small-up.png)` }} />
          )}
        </span>
      </header>
      {!st.min && props.headerExtra}
      {!st.min && <div class="w-body">{props.children}</div>}
    </section>
  );
}

/** Reabre todas as janelas fechadas (botão nas opções). */
export function resetWidgets() {
  try { for (const k of Object.keys(localStorage)) if (k.startsWith('noxara.widget.')) localStorage.removeItem(k); } catch { /* */ }
}

/** Abre (ou fecha, se já estiver aberta) uma janela lateral, como os botões do cliente. */
export function toggleWidget(id: string) {
  const v = load(id);
  save(id, v.closed ? { min: false, closed: false } : { ...v, closed: true });
  window.dispatchEvent(new CustomEvent('noxara-widget', { detail: id }));
}
